import * as React from 'react';

const Logo = () => (
  <img style={{ maxWidth: 50 }} src={`${process.env.PUBLIC_URL}/img/minilogo_or.png`} alt="Logo" />
);

export default Logo;
